































import { Component, Prop } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerInterviewStatusSetCompleted from '@/components/JobWorkerInterviews/JobWorkerInterviewStatusSetCompleted.vue';
import JobWorkerInterviewStatusSetCancelled from '@/components/JobWorkerInterviews/JobWorkerInterviewStatusSetCancelled.vue';
import JobWorkerInterviewStatus from '@/models/JobWorkerInterviews/JobWorkerInterviewStatus';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';

@Component({
    name: 'JobWorkerInterviewStatusSet',
    components: { JobWorkerInterviewStatusSetCancelled, JobWorkerInterviewStatusSetCompleted }
})
export default class extends GiganautVueDialog {
 
   @Prop({required: true})
  jobWorkerInterview: JobWorkerInterviewDto;
  @Prop({required: true})
  jobWorkerStatus: JobWorkerStatus;
  jobWorkerInterviewStatus = JobWorkerInterviewStatus;
  menu = false;

  get disabled() {
		if (this.jobWorkerStatus === JobWorkerStatus.InterviewOne || this.jobWorkerStatus === JobWorkerStatus.InterviewTwo) {
            return false;
        }
        return true;
	}

  get showWorkerConfirmed() {
		return (!this.jobWorkerInterview.workerConfirmedById && !this.jobWorkerInterview.workerDeclinedById);
	}

  get showContactConfirmed() {
		return (!this.jobWorkerInterview.contactConfirmedById && !this.jobWorkerInterview.contactDeclinedById);
	}

  async setStatusToWorkerConfirmed() {
    await JobDetailsModule.confirmJobWorkerInterviewForWorker(this.jobWorkerInterview.id);
  }

  async setStatusToContactConfirmed() {
    await JobDetailsModule.confirmJobWorkerInterviewForContact(this.jobWorkerInterview.id);
  }
}
